import * as React from 'react';
import { ExtensionComponentProps } from 'piral-core';
import { Search, SearchProps } from '@piral/portal-utils';

export function SearchExtension<T>({ params }: ExtensionComponentProps<SearchProps<T>>) {
  return <Search {...params} />;
}
